const MENU_SELECTION_TOGGLE = "menu-selection-toggle";

import { Controller } from "@hotwired/stimulus";
import { enter, leave } from "el-transition";

export default class extends Controller {
  static targets = ["menu", "panel", "background"];
  static values = { toggled: Boolean, remoteKey: String, animate: Boolean };

  connect() {
    // Keep the bound handler so disconnect() can remove this exact listener;
    // otherwise every Turbo visit leaves another one on document.
    this.boundRemoteToggle = this.remoteToggle.bind(this);
    document.addEventListener(MENU_SELECTION_TOGGLE, this.boundRemoteToggle);
    if (this.hasAnimateValue) {
      this.toggle();
    }
  }

  disconnect() {
    document.removeEventListener(MENU_SELECTION_TOGGLE, this.boundRemoteToggle);
  }

  toggle() {
    if (this.toggledValue) {
      this.toggledValue = false;
      leave(this.menuTarget);
      if (this.hasPanelTarget) {
        leave(this.panelTarget);
      }
      if (this.hasBackgroundTarget) {
        leave(this.backgroundTarget);
      }
    } else {
      this.toggledValue = true;
      enter(this.menuTarget);
      if (this.hasPanelTarget) {
        enter(this.panelTarget);
      }
      if (this.hasBackgroundTarget) {
        enter(this.backgroundTarget);
      }
    }
  }

  sendEvent(event) {
    event.stopImmediatePropagation();

    const selectionEvent = new CustomEvent(MENU_SELECTION_TOGGLE, {
      detail: {
        remoteKey: this.remoteKeyValue,
      },
    });
    document.dispatchEvent(selectionEvent);
    return false;
  }

  remoteToggle(event) {
    if (this.hasMenuTarget && event.detail.remoteKey === this.remoteKeyValue) {
      this.toggle();
    }
  }
}
